import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-payment-panel-adyen-googlepay',
  templateUrl: './payment-panel-adyen-googlepay.component.html',
  standalone: false,
})
export class PaymentPanelAdyenGooglepayComponent {
  @Input() clientKey?: string;
  @Input() useTestApi?: boolean;
  @Input() googlePayMerchantName?: string;
  @Input() googlePayMerchantId?: string;
  @Input() googlePayGatewayMerchantId?: string;
  @Input() paymentMethodCbAvailable?: string;
  @Input() paymentMethodPaypalAvailable = false;
  @Input() paymentMethodGooglePayAvailable = false;
  @Input() paymentMethodApplePayAvailable = false;
}
